import React from 'react';
import { Link } from 'react-router-dom';
import { StyledContactWrapper } from './Contact.style';
import SocialIcon from './SocialIcon';
import { StyledSocialIconWrapper } from './SocialIcon.style';
import SectionTitle from '../../../SectionTitle.style';
import GoogleMap from './GoogleMap';
import { scrollToTop } from '../../../ScrollToTop';

function Contact() {
  return (
    <>
      <StyledContactWrapper id="contact">
        <SectionTitle style={{ paddingTop: '2rem' }}> Contact </SectionTitle>
        <h4 style={{ fontStyle: 'italic' }}> © 2020 Shapira Bros Productions </h4>
        <div style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
          <Link
            to="/privacy-policy"
            onClick={scrollToTop(false)}
            style={{
              color: '#fdcb6e',
              textDecoration: 'none',
              transition: 'color 0.3s ease',
            }}
            onMouseEnter={(e) => { e.target.style.color = '#e17055'; }}
            onMouseLeave={(e) => { e.target.style.color = '#fdcb6e'; }}
          >
            Privacy Policy
          </Link>
        </div>
        <div className="center-container">
          <div className="contact-grid-left">
            <a href="mailto:don@shapira-bros.com" className="grid-left-item mail">
              <i className="fas fa-envelope" />
              <p style={{ margin: '10px 15px' }}>don@shapira-bros.com</p>
            </a>
            <a href="tel:+19293545277" className="grid-left-item phone">
              <i className="fas fa-phone" />
              <p style={{ margin: '10px 15px' }}>+1 929-354-5277</p>
            </a>
          </div>
          <div className="contact-grid-right">
            <h3 style={{ paddingBottom: '10px' }}> Follow us </h3>
            <StyledSocialIconWrapper>
              <SocialIcon iconUrl="https://www.facebook.com/ShapiraBros/" iconName="fab fa-facebook-f" iconColor="#3b5998" />
              <SocialIcon iconUrl="https://www.instagram.com/shapirabros/" iconName="fab fa-instagram" iconColor="#e86a45" />
              <SocialIcon iconUrl="https://vimeo.com/user106811963" iconName="fab fa-vimeo-v" iconColor="#45bbff" />
              <SocialIcon iconUrl="https://www.linkedin.com/in/shapira-bros-090517199/" iconName="fab fa-linkedin-in" iconColor="#0077B5" />
            </StyledSocialIconWrapper>
          </div>
        </div>
        <div>
          <i className="fas fa-address-card fa-2x" />
          <h5 style={{ margin: 0, paddingBottom: '20px' }}> based in New York </h5>
        </div>
      </StyledContactWrapper>
      <GoogleMap />
    </>
  );
}

export default Contact;
